<customer-wrapper [showBreadcrumb]="false">
  <ng-container main-content>
    <div class="metrics-dashboard">
      <div class="metrics-header">
        <div class="page-title">
          <img src="assets/icons/metrics-dashboard.svg">
          <div>Metrics Dashboard</div>
        </div>
        <div class="range-selector">
          <button *ngFor="let range of ranges"
                  class="range-button"
                  [class.active]="range === selectedRange"
                  (click)="selectRange(range)">
            {{ range.label }}
          </button>
        </div>
      </div>

      <div class="current-hint" *ngIf="currentMonthHint && data.length">
        <img src="assets/icons/information-outline.svg">
        <span>{{ currentMonthHint }}</span>
      </div>

      <div class="position-relative">
        <div class="loading-shade" *ngIf="isLoading">
          <div class="loading-spinner"></div>
        </div>

        <section class="kpi-row">
          <count-card label="Current Storage ({{ currentStorage.unit }})" [count]="currentStorage.value" icon="database" subtext="latest month"></count-card>
          <count-card class="clickable" (click)="openBreakdown('incidents')" label="Incidents Created" [count]="incidentsTotal" icon="bulletlist" [subtext]="rangeLabel"></count-card>
          <count-card class="clickable" (click)="openBreakdown('uniqueUsers')" label="Unique Users" [count]="uniqueUsers" icon="group" subtext="deduplicated"></count-card>
          <count-card class="clickable" (click)="openBreakdown('video')" label="Video Streamed (mins)" [count]="videoMinutes" icon="camera" [subtext]="rangeLabel"></count-card>
          <count-card class="clickable" (click)="openBreakdown('redaction')" label="Redaction (mins)" [count]="redactionMinutes" icon="seatbelt" [subtext]="rangeLabel"></count-card>
          <count-card class="clickable" (click)="openBreakdown('clipsAdded')" label="Clips Added" [count]="clipsAddedTotal" icon="slideshow" [subtext]="rangeLabel"></count-card>
          <count-card class="clickable" (click)="openBreakdown('clipData')" label="Clip Data Added ({{ clipDataAdded.unit }})" [count]="clipDataAdded.value" icon="download" [subtext]="rangeLabel"></count-card>
        </section>

        <section class="chart-card featured" *ngIf="featuredChart && featuredChart.series.length">
          <div class="chart-title">{{ featuredChart.title }}</div>
          <div class="chart-body">
            <tenant-stack-bar-chart
              [chartId]="featuredChart.id"
              [unit]="featuredChart.unit"
              [formatValue]="featuredChart.formatValue"
              [categories]="stackCategories"
              [series]="featuredChart.series">
            </tenant-stack-bar-chart>
          </div>
        </section>

        <section class="charts-grid" *ngIf="stackCharts.length">
          <ng-container *ngFor="let chart of stackCharts">
            <div class="chart-card" *ngIf="chart.series.length">
              <div class="chart-title">{{ chart.title }}</div>
              <div class="chart-body">
                <tenant-stack-bar-chart
                  [chartId]="chart.id"
                  [unit]="chart.unit"
                  [formatValue]="chart.formatValue"
                  [categories]="stackCategories"
                  [series]="chart.series">
                </tenant-stack-bar-chart>
              </div>
            </div>
          </ng-container>
        </section>
      </div>
    </div>

    <!-- Clicking a KPI tile opens the exact per-tenant totals for the selected range. The per-tenant
         chart for each metric already lives on the main page, so this is a precise-figures table. -->
    <div class="breakdown-overlay" *ngIf="breakdownOpen" (click)="closeBreakdown()">
      <div class="breakdown-modal" (click)="$event.stopPropagation()">
        <div class="breakdown-header">
          <div class="breakdown-title">{{ breakdownTitle }} — {{ rangeLabel }}</div>
          <button class="breakdown-close" type="button" (click)="closeBreakdown()">✕</button>
        </div>
        <div class="breakdown-body">
          <div class="breakdown-message" *ngIf="breakdownLoading">Loading…</div>

          <table class="breakdown-table" *ngIf="!breakdownLoading && breakdownRows.length">
            <thead>
              <tr><th>Tenant</th><th class="value-col">{{ breakdownTitle }}</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of breakdownRows">
                <td>{{ row.tenant }}</td>
                <td class="value-col">{{ row.display }}</td>
              </tr>
            </tbody>
          </table>
          <div class="breakdown-message" *ngIf="!breakdownLoading && !breakdownRows.length">
            No tenant activity for this metric in the selected range.
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</customer-wrapper>
